import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../hooks";
import { searchRegex } from "../../../../constant";

interface SelectedCarProps {
  image_path: string;
  name: string;
  Segment: string;
}

export const useCarSelector = ({ activeCar, getNewCars, getSelectedCar }) => {
  const { fetchByAttr } = useService("Data", "carModel");
  const { getLoggedInUserData, isUserLoggedIn } = useService("User");
  const { closeModal, setActiveCar, getActiveCar } = useService("Misc");
  const { getLocationData } = useService("Router");
  const { getCarManufacturers: getManufacturers, getCars } = useService("Car");
  const targetModal = "car-select-modal";
  const [searchCarKey, setsearchCarKey] = useState<string>("");
  const [carSeleted, setcarSeleted] = useState<boolean>(false);
  const [carManufactureList, setcarManufactureList] = useState([]);
  const [filteredManufacturerList, setfilteredManufacturerList] = useState([]);
  const [selectedCar, setselectedCar] = useState<
    SelectedCarProps | undefined
  >();
  const [carList, setcarList] = useState([]);
  const [userCarList, setuserCarList] = useState([]);
  const [showCarSelectModal, setshowCarSelectModal] = useState<boolean>(false);
  const [showCarListModal, setshowCarListModal] = useState<boolean>(false);

  const getCarManufacturers = useCallback(async () => {
    const result = await getManufacturers();
    if (result.status) {
      if (result.data?.length !== 0) {
        setcarManufactureList(result.data);
        setfilteredManufacturerList(result.data);
      }
    }
  }, [getManufacturers]);

  const getCarManufacturerCars = useCallback(
    async (manufacturer: string) => {
      const result = await fetchByAttr({ manufacturer });
      if (result.data?.length !== 0) {
        setcarList(result.data);
        setshowCarSelectModal(false);
        setshowCarListModal(true);
        closeModal("car-select-modal");
      }
    },
    [closeModal, fetchByAttr]
  );

  const getCarsData = useCallback(async () => {
    const result = await getCars({ ownerId: getLoggedInUserData().uid });
    if (result.status) {
      if (result.data?.length !== 0) {
        setuserCarList(result.data);
        let activeCar = getActiveCar() ? getActiveCar() : null;
        setselectedCar(activeCar);
        setcarSeleted(true);
        setActiveCar(activeCar);
      }
    }
  }, [getActiveCar, getCars, getLoggedInUserData, setActiveCar]);
  const openCarList = useCallback(
    (fileName: string) => {
      getCarManufacturerCars(fileName);
    },
    [getCarManufacturerCars]
  );

  const showSelectedCar = useCallback(
    (activeCar, carSelector?: "old" | "new") => {
      if (carSelector === "new" && !getNewCars) {
        setselectedCar(activeCar);
      } else {
        setselectedCar(activeCar);
        setshowCarListModal(false);
      }
      setcarSeleted(true);
      setActiveCar(activeCar);
      getSelectedCar(activeCar);
      if (
        getLocationData().href.includes("service") ||
        getLocationData().href.includes("packages")
      )
        getLocationData().reload();
    },
    [getLocationData, getNewCars, getSelectedCar, setActiveCar]
  );

  const deselectCar = useCallback(() => {
    setcarSeleted(false);
    localStorage.removeItem("activeCar");
    if (
      getLocationData().href.includes("service") ||
      getLocationData().href.includes("packages")
    )
      getLocationData().reload();
  }, [getLocationData]);

  const search = useCallback(
    (e) => {
      if (e.target.value === "" || searchRegex.test(e.target.value)) {
        setsearchCarKey(e.target.value);
        let tempTitle = "",
          filteredManufacturerList = [];
        carManufactureList.forEach((e) => {
          tempTitle = e.name.toLowerCase();
          if (tempTitle.search(searchCarKey.toLowerCase()) !== -1) {
            filteredManufacturerList.push(e);
          }
        });
        setfilteredManufacturerList(filteredManufacturerList);
      }
    },
    [carManufactureList, searchCarKey]
  );

  const hideCarSelectModal = () => setshowCarSelectModal(false);

  const hideCarListModal = () => setshowCarListModal(false);

  const selectCar = useCallback(() => {
    if (isUserLoggedIn() && !getNewCars && userCarList.length !== 0)
      setshowCarListModal(true);
    else if (targetModal === "car-select-modal") setshowCarSelectModal(true);
    else setshowCarListModal(true);
  }, [getNewCars, isUserLoggedIn, userCarList.length]);

  useEffect(() => {
    if (carManufactureList.length === 0) getCarManufacturers();
    let selectedCar = null;
    if (selectedCar !== null) selectedCar = getActiveCar();
    if (selectedCar !== null) {
      setselectedCar(selectedCar);
      setcarSeleted(true);
    }
    if (isUserLoggedIn() && !getNewCars) getCarsData();
    if (activeCar !== selectedCar && activeCar !== null && activeCar) {
      setselectedCar(activeCar);
      setcarSeleted(true);
    }
  }, [
    activeCar,
    carManufactureList.length,
    getActiveCar,
    getCarManufacturers,
    getCarsData,
    getNewCars,
    isUserLoggedIn,
  ]);

  useEffect(() => {
    if (activeCar !== selectedCar && activeCar !== null && activeCar) {
      setselectedCar(activeCar);
      setcarSeleted(true);
    }
  }, [activeCar, selectedCar]);

  return {
    openCarList,
    showSelectedCar,
    deselectCar,
    search,
    hideCarSelectModal,
    hideCarListModal,
    selectCar,
    carSeleted,
    selectedCar,
    userCarList,
    carList,
    showCarSelectModal,
    searchCarKey,
    filteredManufacturerList,
    showCarListModal,
  };
};
